import { Link, useNavigate } from "react-router-dom";
import { Trash2, Minus, Plus, ShoppingCart } from "lucide-react";
import { useCart } from "../context/CartContext";
import { rupiah } from "../lib/format";
import { ShippingCalculator } from "../components/ShippingCalculator";

export default function Cart() {
  const { items, updateQty, removeItem, subtotal } = useCart();
  const nav = useNavigate();

  if (items.length === 0)
    return (
      <div className="max-w-3xl mx-auto px-6 py-24 text-center" data-testid="cart-empty">
        <ShoppingCart size={48} className="mx-auto text-stone-300" />
        <h2 className="font-display text-xl font-bold text-stone-800 mt-4">Keranjang masih kosong</h2>
        <p className="text-stone-500 mt-1">Yuk cari barang grosir langsung dari China.</p>
        <Link to="/katalog" className="inline-block mt-5 bg-emerald-600 hover:bg-emerald-700 text-white font-semibold px-6 py-2.5 rounded-full">Mulai Belanja</Link>
      </div>
    );

  return (
    <div className="max-w-5xl mx-auto px-6 py-8">
      <h1 className="font-display text-2xl font-bold text-stone-900 mb-6">Keranjang Belanja</h1>
      <div className="grid lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2 space-y-3">
          {items.map((it, i) => (
            <div key={i} data-testid={`cart-item-${it.slug}`} className="flex gap-4 bg-white rounded-2xl border border-stone-200 p-4">
              <img src={it.image} alt={it.title} className="w-20 h-20 rounded-lg object-cover" />
              <div className="flex-1">
                <h3 className="text-sm font-medium text-stone-800 line-clamp-2">{it.title}</h3>
                {Object.keys(it.variant || {}).length > 0 && (
                  <p className="text-xs text-stone-400 mt-0.5">{Object.entries(it.variant).map(([k, v]) => `${k}: ${v}`).join(", ")}</p>
                )}
                <p className="text-emerald-700 font-bold mt-1">{rupiah(it.price_idr)}</p>
              </div>
              <div className="flex flex-col items-end justify-between">
                <button data-testid={`cart-remove-${it.slug}`} onClick={() => removeItem(i)} className="text-stone-400 hover:text-red-600"><Trash2 size={18} /></button>
                <div className="flex items-center border border-stone-200 rounded-lg">
                  <button onClick={() => updateQty(i, it.qty - 1)} className="p-1.5 text-stone-500"><Minus size={14} /></button>
                  <span className="w-8 text-center text-sm font-semibold">{it.qty}</span>
                  <button onClick={() => updateQty(i, it.qty + 1)} className="p-1.5 text-stone-500"><Plus size={14} /></button>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="bg-white rounded-2xl border border-stone-200 p-5 h-fit sticky top-20">
          <h3 className="font-display font-semibold text-stone-900 mb-4">Ringkasan</h3>
          <div className="flex justify-between text-sm text-stone-600 mb-2"><span>Subtotal barang</span><b data-testid="cart-subtotal">{rupiah(subtotal)}</b></div>
          <p className="text-xs text-stone-400 mb-4">Ongkir China→Indo & biaya kedai dihitung di checkout.</p>
          <button data-testid="cart-checkout-btn" onClick={() => nav("/checkout")} className="w-full bg-emerald-600 hover:bg-emerald-700 text-white font-semibold py-3 rounded-xl transition">Lanjut ke Checkout</button>
        </div>
      </div>
      <ShippingCalculator items={items} />
    </div>
  );
}
